export default __webpack_public_path__ + "static/media/Whitepaper-KittyNFT.0caf2484.pdf";